import Typography from '@mui/material/Typography';
import CashFlowData from './PaymentsList';

const OutflowPayments =({ refreshKey, onAddPayment }: { refreshKey?: number; onAddPayment?: () => void }) => {
    return(
      <>
       <Typography>
         <CashFlowData accountType={'Outflow'} type={'account-payable'} refreshKey={refreshKey} onAddPayment={onAddPayment} />
       </Typography>
       </>
       );
}; 
export default OutflowPayments;
